// extracted by mini-css-extract-plugin
module.exports = {"color":"style_color__N3DqC","swatch":"style_swatch__3-Huy","popover":"style_popover__2sEoo","cover":"style_cover__1Typn"};